import { render, staticRenderFns } from "./TheTag.vue?vue&type=template&id=5c4abf63&scoped=true"
import script from "./TheTag.vue?vue&type=script&lang=js"
export * from "./TheTag.vue?vue&type=script&lang=js"
import style0 from "./TheTag.vue?vue&type=style&index=0&id=5c4abf63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4abf63",
  null
  
)

export default component.exports